/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Коллекция для корзины
   */
  app.Cart = app.ItemPageableCollection.extend({
    expand: 'item,wish_item,gifts_discount,reserve,3_price_2_discount,large_family',

    model: app.CartItem,

    settlementId: null,

    url: app.entryScriptName + '/api/v3/cart-item/',

    mode: 'infinite',
    sortTypes: ['-created', '-date', 'price', '-price', 'price-unit', '-price-unit', 'name', 'sid', 'discount'],

    requestFilters: false,

    viewTypes: ['list'],

    hasRestrictions: 0,

    isOnlyPositiveQty: null,

    /**
     * Минимальная сумма заказа
     */
    minOrderSum: parseFloat(app.minSumOrder),
    minOrderSumRur: 0,
    isExclusion: 0,

    deliveryExtraPrice: 0,
    deliveryExtraMessage: '',

    isScroll: false,

    // подарки
    gifts: [],
    // подарки за действия
    giftsForActions: [],
    // группы (удаленный склад, сима-ленд)
    groups: [],
    // если синхронизируется с рр
    isSyncing: false,
    itemsNotAvailableInLoan: false,
    discounts: false,
    threeByTwoDiscountSum: {},
    discountSum: 0,
    discountComplete: {},
    // Товары, обновления количества которых ждем
    awaitedItems: {},
    // минимальное количество символов в артикуле для определения где артикул, а где количество товара
    SYMBOLS_IN_ARTICLE: 6,
    // Максимальное количество ключей в массиве артикулов, при добавлении товаров массово.
    KEYS_RESTRICTION: 1000,
    openedAnalogIds: [],
    additionalOptions: ['settlement', 'isSavedAnalogStates', 'needHeaderUpdate'],

    /** @inheritDoc */
    initialize: function (models, options) {
      this.attachOptions(options);
      this.currencySign = app.currentCurrency.sign;
      this.currency = app.currentCurrency;
      this.cartInfo = {
        sum: app.cartSum,
        items_count: app.cartQty,
        units_count: 0,
        cart_discount: 0,
        sum_with_discount: 0,
        fast_delivery_sum: app.fastDeliverySum,
      };
      this.cartSummaryBlocks = null;
      this.itemsNotAvailableInLoan = new app.Collection();
      this.discountSum = app.cartDiscountSum;
      this.discounts = new app.Discounts();
      this.sort = '-created';

      // Пробрасываем в GTM события добавления в корзину товара
      this.listenTo(this,
        'add',
        function (model) {
          app.recommendationsEvents.trigger('itemInCart', model.get('item_sid'));
          if (app.isMobile || !this.isSavedAnalogStates) {
            this.resetCart();
          } else {
            this.fetch();
          }
        }
      );
      this.listenTo(Backbone, 'minSumUpdated', this.updateMinOrderSum);
      this.updateMinOrderSum(this.settlement);

      // привязываем обработчики к событиям конкретной коллекции
      this.listenTo(this, 'reset updateQty', this._triggerEventOnCartUpdated);
      this.listenTo(Backbone, 'change-currency', function () {
        if (!this.router) {
          this.setCurrency(app.currentCurrency.name);
          this.fetch();
        }
      });
      this.listenTo(this, 'cart-item-refresh', this.cartItemRefresh);
      this.listenTo(Backbone, 'update-cart-info', function (data) {
        _.extend(this.cartInfo, data.cartInfo);
        this.trigger('cart-update');
      });
      this.listenTo(Backbone, 'update-paid-delivery', function (data) {
        this.deliveryExtraPrice = data.paidDelivery.sum;
        this.deliveryExtraMessage = data.paidDelivery.message;
      });
      this.listenTo(Backbone, 'update-discount', function (data) {
        this._parseDiscount(data.discount);
      });
      this.listenTo(this, 'sync', function () {
        this.isFetching = false;
      });
      this.awaitedItems = {};
    },

    defaults: {
      pageSize: 20,
      sort: '-created',
      mode: 'infinite',
      viewtype: 'cards'
    },

    state: {
      firstPage: 1,
      pageSize: 20,
      order: 0
    },

    /**
     * get-параметры для запроса к api (/cart-main/)
     */
    queryParams: {
      totalRecords: null,
      currentPage: 'page',
      pageSize: 'per-page',
      expand: function () {
        var expandCartSummary = '';
        if (app.features.is_cart_summary_blocks) {
          expandCartSummary = ',cart_summary_blocks';
        }
        return this.expand
          + ',volume_discount,wholesale,gifts_discount,badges,item.retail_fee_markup,item.is_in_waiting_list,item.is_available_in_settlement'
          + expandCartSummary;
      },
      currency: function () {
        return app.currentCurrency.name;
      },
      sort: function () {
        return this.sort;
      },
      enable_wholesale_price: 1,
      has_restrictions: function () {
        return this.hasRestrictions;
      },
      is_only_positive_qty: function () {
        return this.isOnlyPositiveQty;
      },
      settlement_id: function () {
        return this.settlementId;
      },
      light_item: 1,
    },

    /**
     * Добавляет сиды к адресу запроса
     * @param sids
     */
    setUrlWithSids: function (sids) {
      if (sids.length) {
        if (_.isUndefined(this.queryParams.sids)) {
          this.queryParams.sids = '';
        }
        this.queryParams.sids += (this.queryParams.sids ? ',' : '') + sids.join(',');
      }
    },

    /**
     * Меняет состояние openedAnalogIds удаляя или добавляя id
     * открытого/закрытого аналога
     * @param {boolean} isHidden Признак открыты/закрыты аналоги
     * @param {number}  itemId   Идентификатор товара
     */
    changeOpenedAnalogId: function (isHidden, itemId) {
      if (isHidden) {
        var index = this.openedAnalogIds.indexOf(itemId);
        if (index !== -1) {
          this.openedAnalogIds.splice(index, 1);
        }
      } else {
        this.openedAnalogIds.push(itemId);
      }
    },

    /**
     * Заполнение коллекции корзины моделями товаров.
     * @param {Object} resp Ответ.
     * @param {Object} options Опций.
     * @param {boolean} options.withoutUpdateCollectionModels Признак - перезаписывать ли коллекцию моделей.
     * @returns {Array} Models Коллекция моделей.
     */
    parseRecords: function (resp, options) {
      this.cartInfo = resp._cart;
      this.totalPages = resp._meta.pageCount;
      this.totalCount = resp._meta.totalCount;
      this.deliveryExtraPrice = resp['_paid-delivery'].sum;
      this.deliveryExtraMessage = resp['_paid-delivery'].message;
      this.costModifiers = resp._cost_modifiers;
      this.gifts = resp._gifts;
      this.threeByTwoDiscount = resp._3_price_2_discount;
      this.giftsForActions = resp._reserve;
      this.groups = resp._groups;
      this.transit_settlements = resp._transit_settlements;
      this._parseDiscount(this.getDiscountData(resp));
      if (resp._items_not_available_in_loan) {
        this._parseItemsNotAvailableInLoan(resp._items_not_available_in_loan);
      }
      if (resp.cart_summary_blocks) {
        this.updateCartSummaryBlocks(resp.cart_summary_blocks);
      }

      return _.isObject(options) && options.withoutUpdateCollectionModels
        ? this.models
        : _.map(resp.items, (function (obj) {
          if (
            _.some(obj.item.attrs,
              {attr_id: app.CUSTOM_QTY_UNITS_ATTR_ID, boolean_value: 1})
            && obj.item.nestedUnit
            && obj.item.in_set > 0
            && obj.item.in_set !== 1
          ) {
            obj.item.has_custom_qty_units = true;
          }
          if ('badges' in obj && 'badges' in resp._meta) {
            obj.badges = app.Item.prototype.getBadges(obj.badges, resp._meta.badges);
          }
          return new this.model(obj, options);
        }).bind(this));
    },

    _parseItemsNotAvailableInLoan: function (itemsNotAvailableInLoanData) {
      if (_.isArray(itemsNotAvailableInLoanData) && itemsNotAvailableInLoanData.length) {
        var result = [];
        _.each(itemsNotAvailableInLoanData, function (itemNotAvailableInLoan) {
          var data = itemNotAvailableInLoan.cart_item;
          data.item = new app.Item(itemNotAvailableInLoan.item);
          result.push(new app.CartItem(data));
        });
        this.itemsNotAvailableInLoan.reset(result);
      }
    },

    _parseDiscount: function (discountData) {
      this.trackDiscountCompleteness(discountData.discounts);
      this.discounts.reset(discountData.discounts);
      this.discountSum = discountData.sum;
      this.threeByTwoDiscountSum = discountData.threeByTwoDiscountSum;
    },

    /**
     * Сохраняем состояние прогресса акций, чтобы перерисовывать при завершении.
     * @param {Object[]} discounts
     */
    trackDiscountCompleteness: function (discounts) {
      var that = this;
      if (discounts) {
        discounts.forEach(function (discount) {
          if (!that.discountComplete.hasOwnProperty(discount.id)) {
            that.discountComplete[discount.id] = discount.isComplete;
          }
          if (that.discountComplete[discount.id] !== discount.isComplete && that.fetchCounter >= 1) {
            that.discountComplete[discount.id] = discount.isComplete;
            if (that.router && that.router.mode === 'infinite') {
              that.trigger('reset-cart');
              that.resetCart();
            } else {
              that.trigger('update-on-discount-complete');
            }
          }
        });
      } else {
        this.discountComplete = {};
      }
    },

    /**
     * Сбрасывание состояния коллекции и переход на первую страницу
     * @param {Boolean} addedBySid
     */
    resetCart: function (addedBySid) {
      this.fullCollection.reset();
      if (this.router && !addedBySid) {
        this.getFirstPage({remove: true});
      } else {
        this.getFirstPage({fetch: true});
      }
    },

    /**
     * Обрабатывает значения общей стоимости.
     * @param {Array} cartSummaryBlocks.
     */
    updateCartSummaryBlocks: function (cartSummaryBlocks) {
      if (Array.isArray(cartSummaryBlocks)) {
        var fractionNumber = app.helpers.NumberHelper.numberWithoutZeroFraction.bind(app.helpers.NumberHelper);
        var updatedCartSummaryBlocks = _.cloneDeep(cartSummaryBlocks);
        updatedCartSummaryBlocks.map(function (line) {
          if (line.price && line.price.value) {
            line.price.value = fractionNumber(line.price.value);
            return line;
          } else {
            return line;
          }
        });
        this.cartSummaryBlocks = updatedCartSummaryBlocks;
      }
    },

    /**
     * Минимальная сумма заказа
     * @returns {*}
     */
    getMinOrderSum: function () {
      return parseFloat(this.minOrderSum);
    },

    updateMinOrderSum: function (model) {
      if (!model) {
        model = this.settlement;
        if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
          Raven.captureException(new Error('TypeError: model is undefined when settlement is ' + this.settlement.get('name')));
        }
      }
      this.minOrderSum = parseFloat(model.get('min_order_sum'));
      this.minOrderSumRur = parseFloat(model.get('min_order_sum_rur'));
      this.isExclusion = model.get('is_exclusion');
      this.trigger('updatedMinSum');
    },

    /**
     * Возвращает сколько ещё денег нужно до оформления минимального заказа
     * @returns {number} остаток до минимального заказа
     */
    getCartSumDeficiency: function () {
      var deficiency = this.getMinOrderSum() - parseFloat(this.cartInfo.sum);
      return deficiency > 0 ? deficiency : 0;
    },

    /**
     * Проверяет больше ли текущая сумма минимальной.
     * @param {number} settlementMinSum Минимальная сумма, если нужно принудительно сравнить с ней
     * @returns {boolean}
     */
    validateMinSum: function (settlementMinSum) {
      settlementMinSum = settlementMinSum || this.getMinOrderSum();
      return this.cartInfo.sum >= settlementMinSum || app.user.get('has_no_order_sum_restrictions');
    },

    /**
     * Проверяет, есть ли товары с удаленного склада
     * @returns {boolean}
     */
    checkRemoteItems: function () {
      if (!this.cartInfo.groups) {
        return false;
      }
      var remoteGroup = _.find(this.cartInfo.groups, { code: 'remote' });
      return remoteGroup.sum > 0;
    },

    /**
     * Возвращает объект с группами, если есть одновременно и товары с удаленного склада, и с локального
     * @returns {Object|null}
     */
    getGroups: function () {
      if (!this.cartInfo.groups) {
        return null;
      }
      var remoteItems = this.getGroupByName('remote');
      if (!(remoteItems && remoteItems.sum)) {
        return null;
      }
      var localItems = this.getGroupByName('local');
      if (!(localItems && localItems.sum)) {
        return null;
      }
      return {
        remote: remoteItems,
        local: localItems
      };
    },

    /**
     * Возвращает объект с группой выбранного названия
     * @param {string} name Название группы
     * @returns {Object|null} Объект с группой
     */
    getGroupByName: function (name) {
      var result;
      if (this.cartInfo.groups) {
        result = _.find(this.cartInfo.groups, { code: name });
      }
      return result || null;
    },

    /**
     * Преобразование массива артикулов и их количества в товар.
     * @param {string[]} numsArray Массив строковых чисел (идентификаторы, количество).
     * @returns {Object[]|[]} Массив товаров.
     */
    mapToProducts: function(numsArray) {
      var varsLength = 0;
      var result = [];
      numsArray.forEach(function (num, index) {
        var nextNum = numsArray[index + 1];
        var product = {};
        if (num.length >= this.SYMBOLS_IN_ARTICLE) {
          product.item_sid = num;
          varsLength += 1;
          if (nextNum && nextNum.length < this.SYMBOLS_IN_ARTICLE) {
            product.qty = Number(nextNum);
            varsLength += 1;
          }
          if (varsLength < this.KEYS_RESTRICTION) {
            result.push(product);
          }
        }
      }.bind(this));

      return result;
    },

    /**
     * Добавление товаров по артикулу
     * @param {string} sidsString
     */
    addByArticul: function (sidsString) {
      var sids = sidsString
        .replace(/[^\d\s,]|\s+/g, ' ') // Заменяет все символы, кроме запятых и одинарных пробелов на пробел
        .split(/[,\s+]/g) // Разделяет строку на массив по пробелу или запятой
        .filter(Boolean),
        requestData = {
          items: this.mapToProducts(sids)
        };
      if (requestData.items.length) {
        $.ajax({
          url: app.entryScriptName + '/api/v3/cart/main/?expand=items',
          type: 'PUT',
          data: requestData,
          success: function (data) {
            this.resetCart(true);
            // отправление данных о добавленных товарах в око
            _.uniqBy(data.items, 'item_sid').forEach(function (item) {
              if (sids.indexOf(String(item.item_sid)) > -1) {
                app.helpers.OkoHelper.push({
                  n: 'add-to-cart',
                  sid: item.item_sid,
                  type_id: 1,
                  q: item.qty,
                  price: item.price
                });
                //отправка события для добавления данных в DataLayer
                this.trigger('pushAddedByArticleToDataLayer', item);
              }
            }.bind(this));
            // событие успешного добавления в корзину по артикулу
            this.trigger('addedCartByArticle', data, requestData.items);
          }.bind(this)
        });
      } else {
        this._handleErrorAddedByArticle(sidsString, sids);
      }
      return requestData;
    },

    /**
     * Смена валюты в корзине и конвертирование минимальных сумм для оформления заказа в выбранную валюту.
     */
    setCurrency: function () {
      app.ItemPageableCollection.prototype.setCurrency.apply(this, arguments);
      this.currency = app.currentCurrency;

      /**
       * Минимальная и фактическая минимальная сумма заказы всегда одинаковы
       * @type {Number}
       */
      this.minOrderSum = parseFloat((this.minOrderSumRur / this.currency.rate).toFixed(2));
      this.trigger('currency-set');
    },

    /**
     * Обновление метаданных корзины после удаления товара из корзины или смены города
     * @param {Object} data
     * @param {Object} deletedModel
     */
    updateAfterCartRefresh: function (data, deletedModel) {
      this.deliveryExtraPrice = data['_paid-delivery'].sum;
      this.deliveryExtraMessage = data['_paid-delivery'].message;
      this._parseDiscount(this.getDiscountData(data));
      this.gifts = data._gifts;
      if (app.gifts) {
        app.gifts.reset(this.gifts);
      }
      if (data.cart_summary_blocks) {
        this.updateCartSummaryBlocks(data.cart_summary_blocks);
      }
      if (data._cart){
        this.cartInfo = data._cart;
        Backbone.trigger('update-cart-info', {cartInfo: data._cart});
      }
      this.transit_settlements = data._transit_settlements;
      // Обновляем информацию о времени доставки у товара только при смене города.
      if (!deletedModel) {
        this.trigger('delivery-info-change');
      } else {
        Backbone.trigger('DeleteItemFromCart');
      }
    },

    /**
     * Обновление информации при удалении из корзины.
     * @param {Object} deletedModel удаляемая модель.
     */
    cartItemRefresh: function (deletedModel) {
      this.settlementIdUrlPart = this.settlementId ? '&settlementId=' + this.settlementId : '';
      this.request = app.entryScriptName + this.url + '?expand=' + this.expand + ',wholesale&light_item=1&v=' + Date.now() + this.settlementIdUrlPart;
      $.get(this.request, function (data) {
        app.cart.updateAfterCartRefresh(data, deletedModel);
      });
    },

    /**
     * Очищает корзину
     */
    clear: function () {
      this.reset();
      this.trigger('clear');
      return $.ajax({
        url: app.entryScriptName + '/api/v3/cart/main/',
        type: 'DELETE'
      });
    },

    /**
     * Удаляет товары из корзины по списку их id.
     * @param {number[]} ids Массив с id товаров, которые должны быть удалены из корзины.
     */
    deleteByItemsIds: function (ids) {
      if (ids && ids.length) {
        var that = this;
        this.sync('delete', this, {
          url: app.entryScriptName + '/api/v3/cart-item/' + ids + '/',
          wait: true,
          method: 'DELETE',
          success: function () {
            // Штатное событие remove не срабатывает при множественном удалении, поэтому инициируем его искусственно.
            _.each(ids, function (id) {
              id = parseInt(id, 10);
              var model = that.findWhere({
                id: id,
              });
              if (model) {
                that.trigger('remove', model);
                Backbone.trigger('changeQtyForOko', 'remove', model.toJSON());
              }
            });
            that.remove(ids);
            that.trigger('removeCheckedFromCart', ids);
            that.fetch();
          }
        });
      }
    },

    /**
     * @inheritDoc
     */
    fetch: function (options) {
      var isNewPage = options && options.from !== options.to;
      if (!this.isFetching || isNewPage) {
        this.isFetching = true;
      /*
       * Добавляем в опции запроса обработчик ошибки.
       */
      var url;

      options = options || {};
      options.error = function (collection, response) {
        if (response.status === 404 && this.router) {
          /*
           * Если в модели есть currentPage
           * (на случай удалениия последнего товара на странице)
           * перекидываем на предыдущую
           */
          if (this.state.currentPage > 1) {
            url = '/p' + (this.state.currentPage - 1);
          } else {
            /*
             * Редирект на первую страницу корзины
             */
            url = '/';
          }
          this.router.navigate(url, {trigger: true}, app.helpers.UrlHelper.getUrlParameters());
        }
      }.bind(this);
      var result = app.ItemPageableCollection.prototype.fetch.call(this, options);
      if (this.queryParams.sids) {
        delete this.queryParams.sids;
      }
      return result;
      }
    },

    /**
     * Переопределен для возможности перехвата ошибок.
     * @param resp
     * @param options
     * @returns {Array}
     */
    parse: function (resp, options) {
      try {
        var newState = this.parseState(resp, _.clone(this.queryParams), _.clone(this.state), options),
          state = _.extend({}, this.state, newState);
        this.setLinks(state);
        if (newState) {
          this.state = this._checkState(state);
        }
        return this.parseRecords(resp, options);
      } catch (e) {
        this.trigger('page-range-error');
      }
      return this.parseRecords(resp, options);
    },

    setLinks: function (state) {
      if (!state) {
        state = this.state;
      }
      if (this.mode === 'infinite') {
        var links = this.links = {};
        var firstPage = state.firstPage;
        var totalPages = Math.ceil(state.totalRecords / state.pageSize);
        var lastPage = firstPage === 0 ? Math.max(0, totalPages - 1) : totalPages || firstPage;
        for (var i = state.firstPage; i <= lastPage; i++) {
          links[i] = this.url;
        }
      }
    },

    /**
     * Устанавливает количество моделей на странице
     * @param pageSize
     * @param options
     * @param page
     * @returns {*|XMLHttpRequest|Backbone.PageableCollection}
     */
    setPageSize: function (pageSize, options, page) {
      if (!pageSize) {
        return this;
      }
      var state,
        totalPages,
        currentPage;

      options = options || {first: false};

      state = this.state;
      totalPages = Math.ceil(state.totalRecords / pageSize);
      currentPage = this.getCurrentPageByPageSize(pageSize);

      state = _.extend({}, state, {
        pageSize: pageSize,
        currentPage: options.first ? state.firstPage : currentPage,
        totalPages: totalPages
      });

      this.setLinks(state);

      state = this.state = this._checkState(state);

      if (page !== this.state.currentPage && page >= 1 && (page <= this.state.totalPages || this.state.totalPages === 0)) {
        state = this.state = this._checkState(_.extend({}, state, {
          currentPage: page
        }));
      }

      return this.getPage(state.currentPage, _.omit(options, ['first']));
    },

    /**
     * Сохранение ссылки на роутер в this.router
     */
    setRouter: function (router) {
        this.router = router;
    },

    /**
     * Добавить айди товара к списку ожидаемых
     * @param {Number} id
     */
    addItemIdToAwaited: function (id) {
      if (_.isNumber(id)){
        this.awaitedItems[id] = true;
      }
    },

    /**
     * Удалить айди товара из списка ожидаемых
     * Если корзина готова, триггерим событие
     * @param {Number} id
     */
    removeItemIdFromAwaited: function (id) {
      if (_.isNumber(id)) {
        delete this.awaitedItems[id];
      }
      if (this.isCartItemsReady()){
        this.trigger('cart:ready-for-validation');
      }
    },

    /**
     * Проверка готовности корзины.
     * Если список ожидаемых товаров пуст, корзина готова
     * @returns {boolean}
     */
    isCartItemsReady: function () {
      return Object.keys(this.awaitedItems).length === 0;
    },

    /**
     * Вызывает события, когда в корзине что-то изменилось.
     * @private
     */
    _triggerEventOnCartUpdated: function () {
      // Не реагируем на события во время синхронизации с РР
      if (!this.isSyncing) {
        if (this.totalCount === 0) {
          this.trigger('empty-cart');
        }
        this.trigger('update');
        if (this.needHeaderUpdate) {
          Backbone.trigger(app.CQC_COMMAND_EVENT, {
            type: app.CQC_COMMAND_TYPES.cartUpdate,
            cart: {
              id: this.cartInfo.cart_id,
              total_items_count: this.cartInfo.items_count,
              positive_balance_cart_sum: this.cartInfo.sum,
              sum_with_discount: this.cartInfo.sum_with_discount,
            },
          });
        }
      }
    },

    /**
     * Обработка ошибок добавления товаров по артикулу.
     * @param {string} sidListString Список артикулов строкой.
     * @param {Array} sidList Список артикулов.
     * @private
     */
    _handleErrorAddedByArticle: function (sidListString, sidList) {
      var data;
      if (Number.parseInt(sidListString)) {
        data = {
          report: sidList.map(function (sid) {
            return {
              item_sid: sid,
              errors: {
                item_sid: 'Артикул должен содержать не менее 6 цифр.',
                qty: 'not available',
              },
            };
          }),
        };
      } else {
        data = {
          report: [
            {
              item_sid: sidListString,
              errors: {
                item_sid: 'Введите правильный артикул.',
                qty: 'not available',
              },
            },
          ],
        };
        sidList = [sidListString];
      }
      this.trigger('addedCartByArticle', data, sidList);
    }
  });
  _.extend(app.Cart.prototype, app.CartDiscountMixin);
})(jQuery);

}.call(window));